import React from 'react';
import { LogoutButton } from './LogoutButton';
import { PrintFormButton } from './SubmitDetailsButton';

/** Logout + Print on one line, right-aligned for safety form toolbars. */
export function FormActionButtons({ className = '' }) {
  return (
    <div className={`flex items-center justify-end gap-3 ${className}`}>
      <PrintFormButton />
      <LogoutButton />
    </div>
  );
}
